import React from 'react';
import { Badge } from '../ui/badge';

const statusStyles = {
  connected: 'bg-success-bg text-success',
  needs_organisation: 'bg-warning-bg text-warning',
  disconnected: 'bg-muted text-muted-foreground',
  error: 'bg-danger-bg text-danger',
  unknown: 'bg-muted text-muted-foreground',
  missing: 'bg-muted text-muted-foreground',
};

const statusLabels = {
  connected: 'Connected',
  needs_organisation: 'Setup incomplete',
  disconnected: 'Not connected',
  error: 'Connection error',
  unknown: 'Not connected',
  missing: 'Not connected',
};

/**
 * Connection health badge. When connected with an organisation name, show it inside the pill.
 * @param {{ status?: string, lastError?: string|object, organisationName?: string|null, className?: string }} props
 */
const ConnectionStatus = ({ status, lastError, organisationName, className = '' }) => {
  const key = status || 'unknown';
  const baseLabel = statusLabels[key] || key;
  const label =
    key === 'connected' && organisationName ? `${baseLabel} · ${organisationName}` : baseLabel;

  return (
    <div className={`flex flex-col gap-1 min-w-0 ${className}`}>
      <Badge className={`${statusStyles[key] || statusStyles.unknown} max-w-full`}>
        <span className='block truncate' title={label}>
          {label}
        </span>
      </Badge>
      {lastError && (
        <p className='text-sm text-danger'>{typeof lastError === 'string' ? lastError : lastError.message}</p>
      )}
    </div>
  );
};

export default ConnectionStatus;
